<template>
  <div id="procesosPendientes">
    <v-card class="elevation-12">
      <v-toolbar dense dark color="blue-grey">
        <v-toolbar-title>Procesos</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn slot="activator" :loading="loading" icon @click="questionBlockServ = true">
            <v-icon>lock</v-icon>
          </v-btn>
          <span>Bloquear servicios Oracle</span>
        </v-tooltip>
        <v-tooltip top>
          <v-btn slot="activator" :loading="loading" icon @click="questionUnlockServ = true">
            <v-icon>lock_open</v-icon>
          </v-btn>
          <span>Desbloquear servicios Oracle</span>
        </v-tooltip>
        <v-chip v-if="bloqueo === false" color="success" text-color="white">
          <v-avatar>
            <v-icon>check_circle</v-icon>
          </v-avatar>
          Servicios Oracle desbloqueados
        </v-chip>
        <v-chip v-else-if="bloqueo === true" color="error" text-color="white">
          <v-avatar>
            <v-icon>block</v-icon>
          </v-avatar>
          Servicios Oracle bloqueados
        </v-chip>
      </v-toolbar>
      <v-card-title>
        <v-btn small :loading="loading" color="info" class="white--text" @click="refresh">Actualizar</v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details maxlength="200"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="procesos" :loading="loading" :search="search"
      rows-per-page-text="Registros por página" :pagination.sync="pagination" class="elevation-1">
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center" @click="showDetailProc(props.item.id)">{{ props.item.id_seg }}</td>
          <td class="text-xs-center" @click="showDetailProc(props.item.id)">{{ props.item.estado_proceso }}</td>
          <td class="text-xs-center" @click="showDetailProc(props.item.id)">{{ props.item.estado_solicitud }}</td>
          <td class="text-xs-center" @click="showDetailProc(props.item.id)">{{ props.item.tipo }}</td>
          <td class="text-xs-center" @click="showDetailProc(props.item.id)">{{ props.item.movimiento }}</td>
          <td class="text-xs-center" @click="showDetailProc(props.item.id)">{{ props.item.id_sol }}</td>
          <td class="text-xs-center" @click="showDetailProc(props.item.id)">{{ props.item.bloqueo }}</td>
          <td class="text-xs-center" @click="showDetailProc(props.item.id)">{{ props.item.fecha_actualizacion }}</td>
          <td class="text-xs-center" @click="showDetailProc(props.item.id)">{{ props.item.usuario_creacion }}</td>
        </template>
        <template slot="pageText" slot-scope="props">
          Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
        <template slot="no-data">
          <div class="text-xs-center"></div>
        </template>
        <template slot="no-results">
          <div class="text-xs-center">
            No se obtuvieron resultados
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogDetProc" fullscreen hide-overlay :persistent="true" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title>Detalle de proceso pendiente</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">GENERAL</h3><br/>
                  <v-text-field v-model="detalle.id_seg" box label="Id" readonly></v-text-field>
                  <v-text-field v-model="detalle.estado_proceso" box label="Estado del proceso" readonly></v-text-field>
                  <v-text-field v-model="detalle.estado_solicitud" box label="Estado de la solicitud " readonly></v-text-field>
                  <v-text-field v-model="detalle.tipo" box label="Tipo" readonly></v-text-field>
                  <v-text-field v-model="detalle.movimiento" box label="Movimiento" readonly></v-text-field>
                  <v-text-field v-model="detalle.id_sol" box label="Id. Solicitud" readonly></v-text-field>
                  <v-text-field v-model="detalle.bloqueo" box label="Bloqueo" readonly></v-text-field>
                  <v-text-field v-model="detalle.fecha_actualizacion" box label="Fecha de actualización" readonly></v-text-field>
                  <v-text-field v-model="detalle.usuario_creacion" box label="Usuario" readonly></v-text-field>
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">MENSAJES</h3><br/>
                  <v-textarea v-model="detalle.entrada" box label="Entrada (XML)"></v-textarea><br/>
                  <v-textarea v-model="detalle.salida" box label="Salida" readonly></v-textarea><br/>
                  <v-textarea v-model="detalle.verificacion" box label="Verificación" readonly></v-textarea><br/>
                  <v-btn block :loading="loading" color="blue-grey" class="white--text" @click="questionUpdEntry = true">
                    Actualizar Entrada
                    <v-icon right dark>refresh</v-icon>
                  </v-btn><br/>
                  <v-btn block :loading="loading" color="blue-grey" class="white--text" @click="questionUnlock = true">
                    Desbloquear
                    <v-icon right dark>lock_open</v-icon>
                  </v-btn><br/>
                  <v-btn block :loading="loading" color="success" class="white--text" @click="questionSend = true">
                    Enviar
                    <v-icon right dark>send</v-icon>
                  </v-btn><br/>
                  <v-btn block :loading="loading" color="info" class="white--text" @click="questionCheck = true">
                    Verificar
                    <v-icon right dark>check</v-icon>
                  </v-btn><br/>
                  <v-btn block :loading="loading" color="error" class="white--text" @click="questionResend = true">
                    Reenviar
                    <v-icon right dark>send</v-icon>
                  </v-btn>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionUpdEntry" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea actualizar la entrada (XML)?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionUpdEntry = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="updateEntry()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionUnlock" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea desbloquear el proceso pendiente?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionUnlock = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="unlock()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionSend" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea enviar el proceso pendiente?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionSend = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="send()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionCheck" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea verificar el proceso pendiente?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionCheck = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="check()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionResend" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea reenviar el proceso pendiente?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionResend = false">Cancelar</v-btn>
          <v-btn flat color="error" @click.native="resend()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionBlockServ" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea bloquear los servicios de Oracle?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionBlockServ = false">Cancelar</v-btn>
          <v-btn flat color="error" @click.native="blockServices()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionUnlockServ" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea desbloquear los servicios de Oracle?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionUnlockServ = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="unlockServices()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando información
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import services from '@/config/services'

export default {
  name: 'procesosPendientes',
  data: () => ({
    loading: false,
    success: false,
    error: false,
    msgSuccess: '',
    msgError: '',
    dialogDetProc: false,
    questionUpdEntry: false,
    questionUnlock: false,
    questionSend: false,
    questionCheck: false,
    questionResend: false,
    questionBlockServ: false,
    questionUnlockServ: false,
    search: '',
    pagination: {
      rowsPerPage: 7
    },
    headers: [
      { text: 'Id', align: 'center', sortable: false, value: 'id_seg' },
      { text: 'Estado del proceso', align: 'center', sortable: false, value: 'estado_proceso' },
      { text: 'Estado de la solicitud', align: 'center', sortable: false, value: 'estado_solicitud' },
      { text: 'Tipo', align: 'center', sortable: false, value: 'tipo' },
      { text: 'Movimiento', align: 'center', sortable: false, value: 'movimiento' },
      { text: 'Id. Solicitud', align: 'center', sortable: false, value: 'id_sol' },
      { text: 'Bloqueo', align: 'center', sortable: false, value: 'bloqueo' },
      { text: 'Fecha de Actualización', align: 'center', sortable: false, value: 'fecha_actualizacion' },
      { text: 'Usuario', align: 'center', sortable: false, value: 'usuario_creacion' }
    ],
    procesos: [],
    detalle: {
      id: '',
      id_seg: '',
      estado: '',
      tipo: '',
      movimiento: '',
      id_sol: '',
      entrada: '',
      salida: '',
      verificacion: '',
      bloqueo: '',
      fecha_actualizacion: '',
      usuario_creacion: ''
    },
    bloqueo: null
  }),
  mounted() {
    this.refresh()
  },
  methods: {
    ws(method, name, data) {
      if (method === 'get') {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          let params = ''
          for (let k in data) {
            params += k + '=' + data[k] + '&'
          }
          params = (params !== '') ? '?' + params : ''
          return axios.get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
      else {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          return axios.post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
    },
    verify() {
      this.ws('get', 'verificarBloqueoServicios')
        .then(res => {
          if (res.ok) {
            this.bloqueo = res.data.bloqueo
          }
          else {
            this.bloqueo = null
          }
        })
    },
    refresh() {
      this.loading = true
      this.ws('get', 'procesosPendientes')
        .then(res => {
          if (res.ok) {
            this.procesos = res.data.procesos
          }
          else {
            this.procesos = []
          }
        })
        .finally(() => {
          this.verify()
          this.loading = false
        })
    },
    close() {
      this.detalle = {
        id: '',
        id_seg: '',
        estado: '',
        tipo: '',
        movimiento: '',
        id_sol: '',
        entrada: '',
        salida: '',
        verificacion: '',
        bloqueo: '',
        fecha_actualizacion: '',
        usuario_creacion: ''
      }
      this.dialogDetProc = false;
    },
    prepareDetailForm (data) {
      this.detalle.id = data.proceso.id
      this.detalle.id_seg = data.proceso.id_seg
      this.detalle.estado_proceso = data.proceso.estado_proceso
      this.detalle.estado_solicitud = data.proceso.estado_solicitud
      this.detalle.tipo = data.proceso.tipo
      this.detalle.movimiento = data.proceso.movimiento
      this.detalle.id_sol = data.proceso.id_sol
      this.detalle.entrada = data.proceso.entrada
      this.detalle.salida = data.proceso.salida
      this.detalle.verificacion = data.proceso.verificacion
      this.detalle.bloqueo = data.proceso.bloqueo
      this.detalle.fecha_actualizacion = data.proceso.fecha_actualizacion
      this.detalle.usuario_creacion = data.proceso.usuario_creacion
      this.dialogDetProc = true
    },
    showDetailProc(id) {
      this.loading = true
      this.ws('get', 'detalleProcesoPendiente', { id })
        .then(res => {
          if (res.ok) {
            this.prepareDetailForm(res.data)
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateEntry() {
      this.questionUpdEntry = false
      this.loading = true
      let data = {
        id: this.detalle.id,
        entrada: this.detalle.entrada
      }
      this.ws('post', 'actualizarEntradaProcesoPendiente', data)
        .then(res => {
          this.close()
          this.refresh()
          if (res.ok) {
            this.success = true
            this.msgSuccess = res.message
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    unlock() {
      this.questionUnlock = false
      this.loading = true
      let id = this.detalle.id
      this.ws('post', 'desbloquearProcesoPendiente', { id })
        .then(res => {
          this.close()
          this.refresh()
          if (res.ok) {
            this.success = true
            this.msgSuccess = res.message
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    send() {
      this.questionSend = false
      this.loading = true
      let id = this.detalle.id
      this.ws('post', 'enviarProcesoPendiente', { id })
        .then(res => {
          this.close()
          this.refresh()
          if (res.ok) {
            this.success = true
            this.msgSuccess = res.message
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    check() {
      this.questionCheck = false
      this.loading = true
      let id = this.detalle.id
      this.ws('post', 'verificarProcesoPendiente', { id })
        .then(res => {
          this.close()
          this.refresh()
          if (res.ok) {
            this.success = true
            this.msgSuccess = res.message
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    resend() {
      this.questionResend = false
      this.loading = true
      let id = this.detalle.id
      this.ws('post', 'reenviarProcesoPendiente', { id })
        .then(res => {
          this.close()
          this.refresh()
          if (res.ok) {
            this.success = true
            this.msgSuccess = res.message
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    blockServices() {
      this.questionBlockServ = false
      this.loading = true
      this.ws('post', 'bloquearServicios')
        .then(res => {
          this.close()
          this.refresh()
          if (res.ok) {
            this.success = true
            this.msgSuccess = res.message
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    unlockServices() {
      this.questionUnlockServ = false
      this.loading = true
      this.ws('post', 'desbloquearServicios')
        .then(res => {
          this.close()
          this.refresh()
          if (res.ok) {
            this.success = true
            this.msgSuccess = res.message
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
